import ShowcaseImage from "./ImageShowcase";

function MiscSectionFallback() {
    return (
        <>
            <ShowcaseImage
            Title='Birthday Card Creator'
            Date='September 9, 2025'
            ImgURL='/birthdayCakeShowcase.png'
            ImgAlt='Birthday Card Creator Screenshot'
            ButtonURL='/create/birthday'
            ButtonText='Create a Birthday Card!'
            EmbedOnLeft={true}
            >
                <p>
                    I created a Birthday Card Creator! Where you can generate a link
                    that you can send to a friend to wish them happy birthday!
                </p>
                <p>
                    In this project I learned how to use react's <code>UseRef</code> to get input from an element.
                    I also learned how to pass search params through the URL.
                </p>
                <br/>
                <p>
                    Click the button to create a birthday card for a friend!
                </p>
            </ShowcaseImage>
        </>
    );
}

export default MiscSectionFallback;